import request from '@/libs/request'

// 广告列表
export function advertList (data) {
  return request({
    url: `advert/list`,
    method: 'get',
    params: data
  })
}

// 上下架
export function changeStatus (data) {
  return request({
    url: `advert/changeStatus`,
    method: 'post',
    data: data
  })
}

// 添加广告
export function addAdv (data) {
  return request({
    url: `advert/edit`,
    method: 'post',
    data: data
  })
}
// 删除幻灯
export function delAdv (id) {
  let data = { advert_id: id}
  return request({
    url: `advert/delete`,
    method: 'post',
    data: data
  })
}
// 幻灯列表
export function advertHdList (data) {
  return request({
    url: `advert/listHd`,
    method: 'get',
    params: data
  })
}
export function changeSort (params) {
  return request({
    url: `advert/changeSort`,
    method: 'get',
    params
  })
}
// 广告详情
export function advertApi (data) {
  return request({
    url: `advert/info`,
    method: 'get',
    params: data
  })
}

// 选择商品
export function selectGoods (data) {
  return request({
    url: `advert/selectGoods`,
    method: 'get',
    params: data
  })
}

// 轮播组列表
export function advGroupList (data) {
  return request({
    url: `advert/groupList`,
    method: 'get',
    params: data
  })
}

// 全部文章
export function homesaty_article_getalllist () {
  return request({
    url: `new/getalllist`,
    method: 'get'
  })
}

// 全部美物
export function goodslist () {
  return request({
    url: `goods/getalllist`,
    method: 'get'
  })
}
export function advertList2 (data) {
  return request({
    url: `advert/list2`,
    method: 'get',
    params: data
  })
}
